import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const CodeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Code",
    children: /*#__PURE__*/_jsx("path", {
      d: "M9.99 9.42a1.4 1.4 0 0 0-1.98 0l-5.6 5.6a1.4 1.4 0 0 0 0 1.98l5.6 5.6c.25.25.6.41.99.41.77 0 1.4-.63 1.4-1.4 0-.39-.16-.74-.41-.99l-4.61-4.61 4.61-4.6a1.4 1.4 0 0 0 0-1.98Zm14 0c-.25-.25-.6-.41-.99-.41-.77 0-1.4.63-1.4 1.4 0 .39.16.74.41.99l4.61 4.6-4.61 4.61c-.25.25-.41.6-.41.99 0 .77.63 1.4 1.4 1.4.39 0 .74-.16.99-.41l5.6-5.6a1.4 1.4 0 0 0 0-1.98l-5.6-5.6Zm-5.85-4.11a1.397 1.397 0 0 0-1.65 1.08s-3.73 18.67-3.73 18.67a1.397 1.397 0 0 0 1.08 1.65s.09 0 .14 0h.15c.67 0 1.24-.48 1.37-1.12s3.73-18.67 3.73-18.67a1.405 1.405 0 0 0-1.09-1.62Z"
    })
  }));
};